import { render, staticRenderFns } from "./feedBack.vue?vue&type=template&id=695974af&scoped=true"
import script from "./feedBack.vue?vue&type=script&lang=js"
export * from "./feedBack.vue?vue&type=script&lang=js"
import style0 from "./feedBack.vue?vue&type=style&index=0&id=695974af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695974af",
  null
  
)

export default component.exports